<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <!--编辑-->
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
    </UPDATE>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update.vue'
//接口地址url的统一管理
import Qs from 'qs'
import URL from "@/views/crs36/util/url"

let goldenStatus= {"0":window.$t("crs.taskGolden.disable"),"1":window.$t("crs.taskGolden.enable")};
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },

  mounted(){

  },
  methods: {
    /*表格按钮点击事件*/
    bthClick (clickName, row) {
      if (clickName == "update"){
        this.$refs.childUpdate.open(row);
      }else if (clickName == "updateStatus"){

          let status = row.goldenStatus == 1 ? 0:1;
          let conf = row.goldenStatus == 1 ? window.$t("crs.taskGolden.disable"):window.$t("crs.taskGolden.enable");
          this.$confirm(window.$t("common.ok")+conf, window.$t("common.tip"), {
            distinguishCancelAndClose: true,
            confirmButtonText: window.$t("common.ok"),
            cancelButtonText: window.$t("common.cancle")
          }).then(() => {
            this.$axios.get(`${URL.taskGolden.audit}/${row.id}`+'/'+status).then(res => {
              if (res.code == 0){
                this.$refs.childTable.defaultGetData(this.queryData);
                this.$message.success("suc");
              }else{
                this.$message.error(res.message);
              }
            });
          })
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data){
      if(window.$t("common.search") == clickName || "查询" == clickName){
        this.queryData = data;
        this.$refs.childTable.defaultQueryData(data);
      }else if(window.$t("common.add")==clickName){
        this.$refs.childUpdate.open();
      }
    },

    /*新增或跟提交数据触发事件*/
    submit(model){
      //根据是否包含id更新还是添加
      this.dataChanage(URL.taskGolden.addOrUpdate,model,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
        }else{
          this.$message.error(res.message);
        }
      })
    },
    dataChanage(url,option,suc,fail){
      this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
        this.$refs.childTable.defaultGetData(this.queryData);
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
        if(fail && (typeof fail == 'function')) fail(res);
      })
    },
  },
  data () {
    return {
      deleteIds:"",
      queryData:{},
      /*新增或更新*/
      updateData:{
        cols:[
          { title: window.$t("crs.task.id"), field: 'id',hidden:true},
          { title: window.$t("crs.taskGolden.goldenName"), field: 'goldenName',required:true},
          { title: window.$t("crs.taskGolden.goldenAlias"), field: 'goldenAlias',required:true},
          { title: window.$t("crs.taskGolden.goldenDesc"), field: 'goldenDesc',required:true},

        ]
      },
      /*from查询表单*/
      formData:{
        hasLable: true,
        cols:[
          { title: window.$t("crs.task.id"), field: 'id',hidden:true},
          { title: window.$t("crs.taskGolden.goldenName"), field: 'goldenName'},
          { title: window.$t("crs.taskGolden.goldenStatus"),field: 'goldenStatus',type:2,optionList:goldenStatus,isNumber:true},
          {click:window.$t("common.search")},
          {click:window.$t("common.add")},
        ]
      },

      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: URL.taskGolden.query,
        selection: false,
        sequence: false,
        method:"get",
        cols: [
          { title: 'ID', field: 'id'},
          { title: window.$t("crs.taskGolden.goldenName"), field: 'goldenName'},
          { title: window.$t("crs.taskGolden.goldenAlias"), field: 'goldenAlias'},
          { title: window.$t("crs.taskGolden.goldenDesc"), field: 'goldenDesc'},
          { title: window.$t("crs.taskGolden.goldenStatus"), field: 'goldenStatus',render:(data)=>{
              return goldenStatus[data];
            }},
          { title: window.$t("crs.taskGolden.creator"), field: 'creator'},
          { title: window.$t("crs.taskGolden.createDate"), field: 'createDate'},
          { title: window.$t("crs.taskGolden.updateDate"), field: 'updateDate'},
          {title: window.$t("common.handle"),width:'330px',btnClick:[
              {
                name:window.$t("common.edit"),click:"update",type:"text"
              },
              {
                name:(data,full)=>{
                  if(full.goldenStatus == 0){
                    return window.$t("crs.taskGolden.enable")
                  }else{
                    return window.$t("crs.taskGolden.disable")
                  }
                },click:"updateStatus",type:"text",confirm:false
              },

            ]
          },
        ]
      }
    }
  }
}
</script>
